var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('paginated-table', {
    attrs: {
      "store": _vm.store,
      "baseQuery": {
        partnerId: _vm.partner.id
      },
      "controlElements": _vm.controlElements,
      "headers": _vm.headers,
      "loading": _vm.isLoadingAll || _vm.isLoading || _vm.load,
      "itemsPerPage": 25
    },
    on: {
      "click:row": _vm.open
    },
    scopedSlots: _vm._u([{
      key: "item.timestamp.created",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
      }
    }, {
      key: "item.folder",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("MessageFolderEnum.".concat(item.folder))) + " ")];
      }
    }, {
      key: "item.body.subject",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.isRead ? _c('strong', [_vm._v(_vm._s(item.body.subject))]) : _c('span', [_vm._v(_vm._s(item.body.subject))])];
      }
    }, {
      key: "item.from",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.folder === _vm.MessageFolderEnum.OUTBOX ? _c('span', [_vm._v(" " + _vm._s(item.to) + " ")]) : _c('span', [_vm._v(" " + _vm._s(item.from) + " ")])];
      }
    }])
  }), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "title": _vm.$t('archive'),
      "leftLoading": _vm.isDeleteDialogLoading,
      "rightLoading": _vm.isDeleteDialogLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.deleteDocument
    }
  }), _vm.selectedDocument ? _c('side-card', {
    attrs: {
      "absolute": true,
      "width": "1200px",
      "fullscreen": _vm.$vuetify.breakpoint.mobile
    },
    on: {
      "close": function close($event) {
        _vm.selectedDocument = null;
      }
    }
  }, [_c('partner-message-detail', {
    attrs: {
      "value": _vm.selectedDocument
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }